module.exports = __webpack_public_path__ + "899ca13ee94b87af9b733b18cd41e5c6.png";